module.exports = __webpack_public_path__ + "img/tr.39c440eb.jpg";